import { render } from "./Keeper.vue?vue&type=template&id=0ef4508a&scoped=true"
import script from "./Keeper.vue?vue&type=script&lang=js"
export * from "./Keeper.vue?vue&type=script&lang=js"

import "./Keeper.vue?vue&type=style&index=0&id=0ef4508a&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef4508a"]])

export default __exports__